// CSS
import '@/assets/css/payment.scss';

// Event, Dialog

// Api 

// Constant 
import {
  TRANSACTION_STATUS,
  PAYMENT_STATUS_TEXT,
  PAYMENT_STYLE_STATUS_TEXT,
  PAYMENT_STATUS_ICON,
  TRANSACTION_TYPE,
} from "@/constant/payment";

// Extend
import base from '@/scripts/base';

// Component   

export default {

  extends: base,

  components: {
  },

  data() {

    return {
      transactionStatus: TRANSACTION_STATUS,
      paymentStatusText: PAYMENT_STATUS_TEXT,
      paymentStyleStatusText: PAYMENT_STYLE_STATUS_TEXT,
      paymentStatusIcon: PAYMENT_STATUS_ICON,
      transactionType: TRANSACTION_TYPE,
    };
  },

  methods: {
  },
}